'use client';

import { useEffect, useState } from 'react';

export type WindowSize = {
  width: number | undefined;
  height: number | undefined;
};

const initialWindowSize: WindowSize = {
  width: undefined,
  height: undefined,
};

export function useWindowSize(): WindowSize {
  const [windowSize, setWindowSize] = useState<WindowSize>(initialWindowSize);

  useEffect(() => {
    const updateWindowSize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    updateWindowSize();
    window.addEventListener('resize', updateWindowSize);

    return () => window.removeEventListener('resize', updateWindowSize);
  }, []);

  return windowSize;
}
